import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import { Card, Table, Tabs, Pagination } from "antd";
import { usePagination } from "../hooks";
import { asyncWrap } from "../utils/utils";
import axios from "axios";
import Swal from "sweetalert2";
import moment from "moment";
import InvoiceDetailModal from "../component/Invoices/InvoiceDetailModal";
import RetailerList from "../component/RetailerList/RetailerList";

const ListInvoices = (props) => {
  const { status, userId } = props;
  const [showInvoiceModal, setShowInvoiceModal] = useState(false);
  const [invoiceData, setInvoiceData] = useState([]);

  const { data, gotoPage, currentPage, loading, total, fetchData } =
    usePagination(`user-invoice?userId=${userId}&status=${status}`);

  const columns = [
    {
      title: "Date",
      dataIndex: "InvoiceDate",
      key: "InvoiceDate",
    },
    {
      title: "InvoiceID",
      dataIndex: "InvoiceID",
      key: "InvoiceID",
    },
    {
      title: "Amount",
      dataIndex: "TotalAmount",
      key: "TotalAmount",
    },
  ];

  const getInvoiceDetail = async (record) => {
    const [error, result] = await asyncWrap(
      axios.get(`/user-invoice/details?id=${record?.InvoiceID}`)
    );

    if (!result) {
      console.log(error);
      Swal.fire("Error in getting invoice data");
      return;
    }

    setInvoiceData([{...result.data.data[0], InvoiceDate: record?.InvoiceDate}]);
    setShowInvoiceModal(true);
  };

  return (
    <>
      <InvoiceDetailModal 
      invoiceData={invoiceData}
      showInvoiceModal={showInvoiceModal}
      setShowInvoiceModal={setShowInvoiceModal}
      />
      <Table
        size="small"
        bordered
        columns={columns}
        pagination={false}
        dataSource={data}
        onRow={(record, rowIndex) => {
          return {
            onClick: (e) => getInvoiceDetail(record),
          };
        }}
      />
      <nav
        className="mt-4"
        style={{ display: "flex", justifyContent: "flex-end" }}
      >
        <Pagination
          showQuickJumper
          current={currentPage}
          defaultPageSize={10}
          total={total}
          onChange={(page) => gotoPage(page)}
          showSizeChanger={false}
        />
      </nav>
    </>
  );
};

const ViewInvoices = (props) => {
  const location = useLocation();
  const [activated, setActive] = useState(0);

  return (
    <Card title="View Invoices">
      <Tabs
        activeKey={activated.toString()}
        onTabClick={(activeKey) => {
          setActive(parseInt(activeKey));
        }}
      >
        <Tabs.TabPane tab="Wholesaler" key="0">
          {/* <ListInvoices status={0} userId={location.state.userId} /> */}
          <RetailerList roleId={5} showInvoice={true} />
        </Tabs.TabPane>
        {/* <Tabs.TabPane tab="Approved" key="1">
          <ListInvoices status={1} userId={location.state.userId} />
        </Tabs.TabPane>
        <Tabs.TabPane tab="Rejected" key="2">
          <ListInvoices status={2} userId={location.state.userId} />
        </Tabs.TabPane> */}
      </Tabs>
    </Card>
  );
};

export default ViewInvoices;
